import { render } from "./ResourcePage.vue?vue&type=template&id=3a6ab42e"
import script from "./ResourcePage.vue?vue&type=script&lang=js"
export * from "./ResourcePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__